<template>
  <v-card @click="showExpensePaid()" :disabled="loading" outlined>
    <v-progress-linear v-show="loading" color="primary" indeterminate></v-progress-linear>
    <v-card-title>
        Avanço Financeiro
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col></v-col>
        <v-col>
          <div style="width: 600px">
            <bar-chart :chart-data="chartData" :options="chartOptions" />
          </div>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { Bar } from "vue-chartjs";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { mapActions } from "vuex";
export default {
  components: { "bar-chart": Bar },
  data() {
    return {
      costId: null,
      loading: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Avanço Finaceiro",
            backgroundColor: "#4caf50",
            borderColor: "#4caf50",
            fill: true,
            data: [],
            order: 1,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("Dashboard", ["getFinancialProgress"]),
    getData() {
      this.loading = true;
      this.getFinancialProgress()
        .then((response) => {
          this.chartData.datasets[0].data = response.data.data;
          this.chartData.labels = response.data.labels;
          this.costId = response.data.cost_id;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showExpensePaid() {
      this.$router.push({ path: '/system/controle_de_insumos/expenses_paid' });

    },
  },
};
</script>
